import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "libs-body" }
const _hoisted_2 = { class: "libs-content" }
const _hoisted_3 = { style: {"background-color":"#F5F5F5","height":"62px"} }
const _hoisted_4 = {
  class: "title-cls",
  style: {"margin-left":"24px","margin-right":"24px","margin-top":"16px"}
}
const _hoisted_5 = {
  class: "tabs-cls",
  style: {"margin-top":"16px","display":"flex"}
}
const _hoisted_6 = { style: {"flex":"1"} }
const _hoisted_7 = {
  class: "seg-tabs",
  style: {"display":"flex","margin":"4px 16px 4px 16px","justify-content":"center"}
}
const _hoisted_8 = { style: {"width":"16px","height":"16px"} }
const _hoisted_9 = { style: {"margin-left":"6px","font-size":"16px","font-weight":"400"} }
const _hoisted_10 = {
  class: "libs-detail",
  style: {"margin-left":"24px","margin-right":"24px","margin-top":"24px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_segmented = _resolveComponent("a-segmented")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_PGALibs = _resolveComponent("PGALibs")!
  const _component_RuleLibs = _resolveComponent("RuleLibs")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_spin, { spinning: _ctx.libLoading }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_breadcrumb, { style: {"height":"22","padding-top":"24px","padding-left":"24px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_breadcrumb_item, null, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("a", { href: "/#" }, "Clearance", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_a_breadcrumb_item, null, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Compl-Libs")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("div", null, [
              _createElementVNode("label", { style: {"font-size":"16px","font-weight":"600","line-height":"22px"} }, "Compliance Library")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_segmented, {
                  value: _ctx.libsType,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.libsType) = $event)),
                  options: _ctx.libsOptions,
                  size: "large",
                  onChange: _ctx.segmentChange
                }, {
                  label: _withCtx(({ payload = {} }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(payload.icon)))
                      ]),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(payload.label), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "options", "onChange"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_a_input_search, {
                  value: _ctx.searchValue,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
                  placeholder: "Search",
                  style: {"width":"240px"},
                  onSearch: _ctx.searchHandle,
                  size: "large",
                  allowClear: ""
                }, null, 8, ["value", "onSearch"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.libsType === 'PGA')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_PGALibs, {
                    ref: "PGARef",
                    onLoad_event: _ctx.show_loading
                  }, null, 8, ["onLoad_event"])
                ]))
              : (_ctx.libsType === 'rules')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_RuleLibs, {
                      ref: "RuleRef",
                      onLoad_event: _ctx.show_loading
                    }, null, 8, ["onLoad_event"])
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["spinning"])
    ])
  ]))
}